import qs from "qs";

import { OTP_HASH_QUERY_PARAM } from "../auth/authOtpConstants";

/** Matches set-password token URLs such as /pl/login/reset-password/:userId/:hash */
export const RESET_PASSWORD_EXECUTE_PATH_REGEX =
  /^(.+\/reset-password)\/[^/]+\/[^/]+\/?$/;

export const AUTH_TOKEN_FOR_LOGIN_QUERY_PARAM = "auth_token_for_login";

/** Query params removed from analytics URLs on every page. */
export const SENSITIVE_ANALYTICS_QUERY_PARAMS = [
  OTP_HASH_QUERY_PARAM,
  AUTH_TOKEN_FOR_LOGIN_QUERY_PARAM
];

function redactResetPasswordPathname(pathname) {
  return pathname.replace(RESET_PASSWORD_EXECUTE_PATH_REGEX, "$1");
}

/**
 * Path-specific redactors run before the default query-param stripping.
 * Keys are stable ids for tests/docs; matching is done via `matchesPathname`.
 */
export const ANALYTICS_URL_PATH_REDACTIONS = {
  "reset-password": {
    matchesPathname: pathname =>
      RESET_PASSWORD_EXECUTE_PATH_REGEX.test(pathname),
    redactPathname: redactResetPasswordPathname
  }
};

export function redactSensitiveQueryParams(
  search,
  paramNames = SENSITIVE_ANALYTICS_QUERY_PARAMS
) {
  if (!search) {
    return "";
  }

  const params = qs.parse(search, { ignoreQueryPrefix: true });

  for (const paramName of paramNames) {
    delete params[paramName];
  }

  const nextSearch = qs.stringify(params, { addQueryPrefix: true });

  return nextSearch === "?" ? "" : nextSearch;
}

export function redactAnalyticsPathname(pathname) {
  for (const rule of Object.values(ANALYTICS_URL_PATH_REDACTIONS)) {
    if (rule.matchesPathname(pathname)) {
      return rule.redactPathname(pathname);
    }
  }

  return pathname;
}

/** Default redaction for all pages: path rules + sensitive query params. Fragments are dropped separately. */
export function applyDefaultAnalyticsUrlRedaction(parsedUrl) {
  const pathname = redactAnalyticsPathname(parsedUrl.pathname);
  const search = redactSensitiveQueryParams(parsedUrl.search);

  return { pathname, search };
}
